import { mapActions } from 'vuex';

export default {
  props: ['shade'],
  methods: {
    ...mapActions('global', ['openModal', 'closeModal']),
    gotoPDP() {
      const prefix = this.getSlug();
      location.href = `${Shopify.routes.root}products/${prefix}-${this.shade}?try-shade=true`;
    },
    getSlug() {
      const slugs = __GLOBAL__.shades.tryShadeOn.split('-');
      slugs.pop();
      return slugs.join('-');
    },
  },
};
